import { render, staticRenderFns } from "./EventSignup.vue?vue&type=template&id=123661fe&scoped=true"
import script from "./EventSignup.vue?vue&type=script&lang=js"
export * from "./EventSignup.vue?vue&type=script&lang=js"
import style0 from "./EventSignup.vue?vue&type=style&index=0&id=123661fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123661fe",
  null
  
)

export default component.exports